import Carousel from "@/components/common/Carousel";
import Bottom from "@/components/common/Bottom";
import Link from "@/components/common/Link";
import Search from "@/components/common/Search";
import Top from "@/components/common/Top";
import ComList from "@/components/common/ComList";
import ImgLink from "@/components/common/ImgLink";
import ImgFloat from "@/components/common/ImgFloat";

import Book from "@/components/media/Book";
import Video from "@/components/media/Video";
import MediaList from "@/components/media/MediaList";

import Navigation from "@/components/nav/Navigation";
import NewsNav from "@/components/nav/NewsNav";

import NewsList from "@/components/news/NewsList";
import Notice from "@/components/news/Notice";
import Work from "@/components/news/WorkData";
import PartNews from "@/components/news/PartNews";
import PartNewsLong from "@/components/news/PartNewsLong";
import RightDetail from "@/components/news/RightDetail";

import WorkTrends from "@/components/party/WorkTrends";
import SpecialSubject from "@/components/party/SpecialSubject";
import PartSubject from "@/components/party/PartSubject";

export default {
  Carousel,
  Bottom,
  Link,
  Search,
  Top,
  Book,
  Navigation,
  NewsNav,
  NewsList,
  Notice,
  Video,
  Work,
  WorkTrends,
  PartNews,
  PartNewsLong,
  SpecialSubject,
  ComList,
  ImgLink,
  PartSubject,
  MediaList,
  RightDetail,
  ImgFloat
}